import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ImportInProductListStatus as SchemaImportInProductListStatus } from '../schemas/ImportInProductListStatus';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags ProductLists
 */
export const GetImportVariantsInProductListStatusContentType = '' as const;
export type GetImportVariantsInProductListStatusRequest = void;
export type GetImportVariantsInProductListStatusResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaImportInProductListStatus;
    };
};
export type GetImportVariantsInProductListStatusResponseSuccess =
    GetImportVariantsInProductListStatusResponses['200']['application/json'];
export type GetImportVariantsInProductListStatusSearchParams = undefined;
export type GetImportVariantsInProductListStatusPathParameters = {
    list_id: string;
};
export const GetImportVariantsInProductListStatusUrl = '/product-lists/{list_id}/variants/import/status/last' as const;
export const GetImportVariantsInProductListStatusMethod = 'GET' as const;
export const getGetImportVariantsInProductListStatusUrl = (
    params: GetImportVariantsInProductListStatusPathParameters
) =>
    GetImportVariantsInProductListStatusUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetImportVariantsInProductListStatusPathParameters) => String(params[param])
    );
